export default {
    required: (value) => !!value || '该项为必填',

    nickName: (str) => {
        var len = str.length
        var result = 0
        for (var i = 0; i < len; i++) {
            if (str.charCodeAt(i) < 27 || str.charCodeAt(i) > 126) {
                result += 2
            } else {
                result++
            }
        }
        return result <= 16 || '昵称最多支持 8 个字符'
    },

    phoneNumber: (val) => {
        var reg = /^1[3456789]\d{9}$/
        return reg.test(val) || `输入的手机号码格式有误`
    }
}
